import SiteList from "../components/SiteList";

function SiteListPage() {
  return <SiteList />;
}

export default SiteListPage;
